/**
 * G-84 (owner 2026-09-17) — where a quantity is sitting, in words.
 *
 * A box IS a zone, so a boxed row already read "3 in BOX-000017": true, and
 * no use to somebody standing in the shop who does not know where that box
 * lives. The box's kept-in zone is the missing half.
 *
 * Pure and in `utils/` because that is where this repo's testable frontend
 * logic goes — the Jest project has no jsx and cannot import a component.
 *
 * G-85: the words come from the dictionary and are built at CALL time, so the
 * sentence is in whatever language the kiosk is showing. The zone and box
 * names inside it are shop data and stay as the owner typed them.
 */
import { t } from "../i18n/t";

export type StockPlace = {
  zoneName: string;
  qty: string;
  box: { code: string; name: string | null; keptInZoneName: string | null } | null;
};

/** "3 in BOX-000017 · Storage", or plainly "12 in Fridge". */
export function placeWords(place: StockPlace): string {
  if (!place.box) {
    return t("itemFinder.placeQty", { qty: place.qty, zone: place.zoneName });
  }
  const where = place.box.keptInZoneName ? ` · ${place.box.keptInZoneName}` : "";
  return `${t("itemFinder.placeQty", { qty: place.qty, zone: place.box.code })}${where}`;
}
